import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Button, ButtonGroup } from "react-bootstrap";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { closeCustomModal, openCustomModal } from "components/custom/modals";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import {
    fetchRetailers,
    deleteRetailer,
    clearRetailers
} from "api/menu/master-files/retailers/actions";

// import RetailerEditModal from "components/menu/master-files/retailers/create-edit-modal";
const RetailerEditModal = React.lazy(() =>
    import("components/menu/master-files/retailers/create-edit-modal"));

class RetailersList extends React.Component {
    constructor(props) {
        super(props);

        this.modalOpen = this.modalOpen.bind(this);
    }

    componentDidMount () {
        this.props.fetchRetailers(true);
    }

    componentWillUnmount () {
        this.props.clearRetailers();
    }

    modalOpen = (retailerId = false) => {
        const modalTitle = retailerId !== false ? "Update" : "Create";

        const modalObj = {
            id: `retailer-${retailerId}`,
            modalSettings: {
                size: "lg"
            },
            header: `${modalTitle} Retailer`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <RetailerEditModal
                        retailerId={retailerId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    delete = (retailerId, name) => {
        this.props.deleteRetailer(retailerId, name, () => this.props.fetchRetailers(true));
    };

    render () {
        const {
            retailers,
            loading
        } = this.props;

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Code",
                accessor: "code",
                id: "code",
            },
            {
                Header: "Name",
                accessor: "name",
                id: "name",
            },
            {
                Header: "Active?",
                id: "isInactive",
                accessor: original => (original.isInactive ? "NO" : "YES"),
                Cell: ({ original }) => (original.isInactive ? "NO" : "YES"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            {
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Button size="sm" onClick={() => this.modalOpen(original.id)}>
                            <FontAwesomeIcon icon="pen" title="Update" />
                        </Button>
                        <Popconfirm
                            title={`Delete "${original.name}"?`}
                            onConfirm={() => this.delete(original.id, original.name)}
                            placement="bottomRight"
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <Button variant="danger" size="sm">
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </Popconfirm>
                    </ButtonGroup>
                ),
                filterable: false,
                width: 100
            }
        ];

        return (
            <div className="dashboard">
                <h3 className="mb-4">Retailers</h3>

                <ReactTable
                    data={retailers}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    defaultSorted={[
                        {
                            id: "code",
                            desc: false
                        }
                    ]}
                    defaultFiltered={[
                        {
                            id: "isInactive",
                            value: "YES"
                        }
                    ]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 200px)",
                    }}
                />

                <div className="mt-4 mb-4 text-right">
                    <Button className="ml-2" variant="primary" onClick={() => this.modalOpen()}>
                        Add New Retailer
                    </Button>
                </div>
            </div>
        );
    }
}

RetailersList.propTypes = {
    fetchRetailers: PropTypes.func.isRequired,
    deleteRetailer: PropTypes.func.isRequired,
    clearRetailers: PropTypes.func.isRequired,

    retailers: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    retailers: state.retailers.retailers,
    loading: state.retailers.loading
});

const mapStateToDispatch = dispatch => ({
    fetchRetailers: bindActionCreators(fetchRetailers, dispatch),
    deleteRetailer: bindActionCreators(deleteRetailer, dispatch),
    clearRetailers: bindActionCreators(clearRetailers, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(RetailersList);
